export const ANIMATION_DURATION = 0.5;

export const ANIMATION_EASE = "easeInOut";
